import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router";

import { Button } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Input, FormControl, MenuItem, Select } from "@mui/material";

import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";

import plusIcon from "@user/assets/images/common/plus-secondary.svg";
import minusIcon from "@user/assets/images/common/minus-secondary.svg";

interface State {
}

const defState = {
};

interface Info {
  inoutType: string,
  inoutDetailType: string,
  trackingId: string,
  pn: string,
  trNo: string,
  sn: string,
  kwd: string,
  ctg: string,
  reqQty: string,
  uom: string,
  workShop: string,
  wo: string,
  visitNo: string,
  hl: string,
  requester: string,
  remark: string,
  urgentStatus: string,
  conditionContent: string,
  toOrg: string,
  toSubinv: string,
  deliveryTo: string,
  addRemark: string,
  wh: string
}

const defInfo: Info = {
  inoutType: "",
  inoutDetailType: "",
  trackingId: "",
  pn: "",
  trNo: "",
  sn: "",
  kwd: "",
  ctg: "",
  reqQty: "",
  uom: "",
  workShop: "",
  wo: "",
  visitNo: "",
  hl: "",
  requester: "",
  remark: "",
  urgentStatus: "",
  conditionContent: "",
  toOrg: "",
  toSubinv: "",
  deliveryTo: "",
  addRemark: "",
  wh: ""
};

const validationMsg = [
  {id: "inoutType", type: "NotBlank", msg: "작업구분을 선택해 주세요."},
  {id: "inoutDetailType", type: "NotBlank", msg: "상세를 선택해 주세요."}
];

function PopupInoutWork(props: any) {
  const [state, setState] = useState<State>(kutil.deepCopy(defState));
  const [info, setInfo] = useState<Info>(kutil.deepCopy(defInfo));

  useEffect(() => {
    init();
  }, []);

  const isInit = useRef(false);
  async function init() {
    try {
      if (isInit.current == false) {
        isInit.current = await initData();
      }
      if (isInit.current) {
        await initParams();
        await searchInfo();
      }
    } finally {
      kutil.setLoadingStatus(false);
    }
  }

  async function initData() {
    return true;
  }

  async function initParams() {
  }

  async function searchInfo() {
  }
 
  async function closePopup() {
    props.onClose();
  }

  async function save() {
    const isValid = await kutil.checkValidation(info, validationMsg);
    if (isValid == false) {
      return;
    }

    if (await kutil.confirm("등록하시겠습니까?") == false) {
      return false;
    }

    try {
      const data = await kutil.sendPost("/api/sample/popup_inout_work.proc?mode=add", info, {
        validationMsg: validationMsg
      });
      await kutil.alert("등록하였습니다.");
      props.onClose({isSuccess: true});
    } catch(e) {
      console.log(e);
    }
  }

  return (
    <>
      {/* 팝업 */}
      <Dialog
        sx={{ "& .MuiDialog-container": { "& .MuiPaper-root": { width: "100%", maxWidth: "1200px", }, }, }}
        aria-labelledby="customized-dialog-title"
        open={props.isShow}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          ERP 작업지시 등록(임시)
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={closePopup}
          sx={(theme) => ({
            position: "absolute",
            right: 36,
            top: 24,
            color: theme.palette.grey[500],
          })}
        >
        </IconButton>
        <DialogContent>
          {/* 팝업 내용 */}
          <div className="popup-contents">
            {/* 등록 내용 */}
            <div className="table-wrap">
              <table>
                <colgroup>
                  <col style={{ width: "11%" }} />
                  <col style={{ width: "22%" }} />
                  <col style={{ width: "11%" }} />
                  <col style={{ width: "23%" }} />
                  <col style={{ width: "11%" }} />
                  <col style={{ width: "22%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">작업구분</th>
                    <td>
                      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <Select
                          value={info.inoutType}
                          onChange={(e) => {setInfo(prev => ({ ...prev, inoutType: e.target.value }))}}
                          displayEmpty
                        >
                          <MenuItem value="">선택</MenuItem>
                          {(commonCode.inoutType as any[]).map((code) => (
                            <MenuItem key={code.code} value={code.code}>{code.value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>
                    <th scope="row">상세</th>
                    <td>
                      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <Select
                          value={info.inoutDetailType}
                          onChange={(e) => {setInfo(prev => ({ ...prev, inoutDetailType: e.target.value }))}}
                          displayEmpty
                        >
                          <MenuItem value="">선택</MenuItem>
                          {(commonCode.inoutDetailType as any[]).map((code) => (
                            <MenuItem key={code.code} value={code.code}>{code.value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>
                    <th scope="row">Tracking ID</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.trackingId}
                        onChange={(e) => {setInfo(prev => ({ ...prev, trackingId: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="Tracking ID"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">작업상태,<br />Creat Date</th>
                    <td>작업대기, 등록일시 저장</td>
                    <th scope="row">P/N</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.pn}
                        onChange={(e) => {setInfo(prev => ({ ...prev, pn: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="파트넘버"
                      />
                    </td>
                    <th scope="row">TR No</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.trNo}
                        onChange={(e) => {setInfo(prev => ({ ...prev, trNo: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="TR 넘버"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">S/N</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.sn}
                        onChange={(e) => {setInfo(prev => ({ ...prev, sn: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="시리얼넘버"
                      />
                    </td>
                    <th scope="row">KWD</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.kwd}
                        onChange={(e) => {setInfo(prev => ({ ...prev, kwd: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="키워드"
                      />
                    </td>
                    <th scope="row">CTG</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.ctg}
                        onChange={(e) => {setInfo(prev => ({ ...prev, ctg: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="카테고리"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">REQUEST<br />QTY</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 7 }}
                        value={info.reqQty}
                        onChange={(e) => {setInfo(prev => ({ ...prev, reqQty: valueFormatter.number(valueFormatter.numberParser(e.target.value)) }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="수량"
                      />
                    </td>
                    <th scope="row">UOM</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.uom}
                        onChange={(e) => {setInfo(prev => ({ ...prev, uom: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="단위"
                      />
                    </td>
                    <th scope="row">Work Shop</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.workShop}
                        onChange={(e) => {setInfo(prev => ({ ...prev, workShop: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="워크샵"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">W/O</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.wo}
                        onChange={(e) => {setInfo(prev => ({ ...prev, wo: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="워크오더"
                      />
                    </td>
                    <th scope="row">기번(HL)</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.hl}
                        onChange={(e) => {setInfo(prev => ({ ...prev, hl: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="기번(HL)"
                      />
                    </td>
                    <th scope="row">요청자</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.requester}
                        onChange={(e) => {setInfo(prev => ({ ...prev, requester: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="요청자"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">REMARK</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.remark}
                        onChange={(e) => {setInfo(prev => ({ ...prev, remark: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="REMARK"
                      />
                    </td>
                    <th scope="row">긴급여부</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.urgentStatus}
                        onChange={(e) => {setInfo(prev => ({ ...prev, urgentStatus: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="1:CDR 2:ADR 3:SDR 4:Default"
                      />
                    </td>
                    <th scope="row">CONDITION</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.conditionContent}
                        onChange={(e) => {setInfo(prev => ({ ...prev, conditionContent: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="출고티켓 목록형 [CON]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">ORGANIZATION</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.toOrg}
                        onChange={(e) => {setInfo(prev => ({ ...prev, toOrg: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="출고티켓 목록형 [TO]"
                      />
                    </td>
                    <th scope="row">SUBINVENTORY</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.toSubinv}
                        onChange={(e) => {setInfo(prev => ({ ...prev, toSubinv: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="출고티켓 목록형 [DEP]"
                      />
                    </td>
                    <th scope="row">DELIVERY TO</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.deliveryTo}
                        onChange={(e) => {setInfo(prev => ({ ...prev, deliveryTo: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="출고티켓 목록형 [DELIVERY TO]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">REMARK</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.addRemark}
                        onChange={(e) => {setInfo(prev => ({ ...prev, addRemark: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="출고티켓 목록형 [REMARK]"
                      />
                    </td>
                    <th scope="row">창고</th>
                    <td>
                      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <Select
                          value={info.wh}
                          onChange={(e) => {setInfo(prev => ({ ...prev, wh: e.target.value }))}}
                          displayEmpty
                        >
                          <MenuItem value="">선택</MenuItem>
                          {(commonCode.wh as any[]).filter(c => c.code !== "B").map((code) => (
                            <MenuItem key={code.code} value={code.code}>{code.value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>
                    <th scope="row">Visit No</th>
                    <td>
                      <Input
                        inputProps={{ maxLength: 100 }}
                        value={info.visitNo}
                        onChange={(e) => {setInfo(prev => ({ ...prev, visitNo: e.target.value }))}}
                        onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                        placeholder="Visit No"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/*// 등록 내용 */}
          </div>
          {/*// 팝업 내용 */}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" autoFocus onClick={closePopup}>
            취소
          </Button>
          <Button variant="contained" autoFocus onClick={save}>
            저장
          </Button>
        </DialogActions>
      </Dialog>
      {/*// 팝업 */}
    </>
  );
}

export default React.memo(PopupInoutWork);
